import { getPathByName, ROUTES } from 'src/utils/routes/routes';

export const CONTACT_EMAIL = 'info@fisify.com';

export enum LOCALE {
  EN = 'en',
  ES = 'es',
}
export const LOCALES: LOCALE[] = [LOCALE.ES, LOCALE.EN];
export const DEFAULT_LANG: LOCALE = LOCALE.ES;
export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';
export const ACCEPTED_IMAGE_TYPES = ['jpeg', 'jpg', 'png', 'webp'];

export const MOBILE_OR_TABLET_BREAKPOINT = 1024;

export const DAYS_OF_WEEK_TRANSLATION_KEYS = [
  'weekDays.short.monday',
  'weekDays.short.tuesday',
  'weekDays.short.wednesday',
  'weekDays.short.thursday',
  'weekDays.short.friday',
  'weekDays.short.saturday',
  'weekDays.short.sunday',
];

export const PAGES_WITHOUT_Y_OVERFLOW = [getPathByName(ROUTES.profileStats).path];

export const PUBLIC_API_ENDPOINTS = ['/api/partners/validate'];
export const PUBLIC_API_ANALYTICS_PAGE_VIEW_ENDPOINT = '/api/analytics/page-view-event';

export enum SEARCH_PARAM_KEYS {
  Job = 'job',
  Partner = 'partner',
  PartnerCode = 'partnerCode',
  PhysioId = 'physioId',
  Pathology = 'pathology',
  DeviceToken = 'deviceToken',
  Platform = 'platform',
  CallbackUrl = 'callbackUrl',
  User = 'user',
  Email = 'email',
  AuthToken = 'authToken',
}

export enum COOKIE_KEYS {
  Jwt = 'jwt',
}

export const EMAIL_PARTNER_WHITELIST = ['imqsalud'];
export const PARTNERS_WITH_NOTIFICATION_INTEGRATIONS = ['imqsalud'];

// HTTP Status codes
export const UNAUTHORIZED_STATUS_CODE = 401;
export const FORBIDDEN_STATUS_CODE = 403;
